module.exports = __webpack_public_path__ + "img/7-two.c53d8929.png";